import { ajax } from 'cadenza/api-client/api';
import type {
  DataProtectionConfigurationDto,
  DataProtectionDescriptionDto,
} from 'cadenza/api-client/dto/data-protection-dto';
import { isFeatureAvailable } from 'cadenza/features';
import { MIMETYPE_JSON } from 'cadenza/model/media-type';
import type { ObjecttypeIdString } from 'cadenza/repository/model/objecttype-id.gen';
import type { ProjectId } from 'cadenza/repository/model/project-id.gen';

/**
 * Returns the data protection configuration from the backend. If the feature is not
 * available, returns an empty configuration.
 */
export function readDataProtectionConfiguration() {
  if (isFeatureAvailable('DATA_PROTECTION')) {
    return ajax<DataProtectionConfigurationDto>('/config/data-protection');
  }
}

export function readDataProtection(objecttypeId: ObjecttypeIdString) {
  return ajax<DataProtectionDescriptionDto>(`/objecttypes/${window.btoa(objecttypeId)}/data-protection`);
}

export function readProjectDataProtection({ repositoryName, itemName }: ProjectId) {
  return ajax<DataProtectionDescriptionDto>(`/repositories/${repositoryName}/projects/${itemName}/data-protection`);
}

export function saveDataProtectionDescription(
  objecttypeId: ObjecttypeIdString,
  descriptionDto: DataProtectionDescriptionDto,
) {
  return ajax<DataProtectionDescriptionDto>(`/objecttypes/${window.btoa(objecttypeId)}/data-protection`, {
    method: 'PUT',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify(descriptionDto),
  });
}
